import React from "react";
import { IconType } from "../../type/icon_type";

const ChevronRight = (props: IconType) => {
  const { width, height, color, style, onClick, onMouseEnter, onMouseLeave } =
    props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <path
        d="M9 18L15 12L9 6"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronLeft = (props: IconType) => {
  const { width, height, color, style, onClick, onMouseEnter, onMouseLeave } =
    props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <path
        d="M15 18L9 12L15 6"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronDown = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronUp = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M18 15L12 9L6 15"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronUpBlack = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path d="M14.5 12.5L10 7L5.5 12.5" fill="#464C52" />
      <path
        d="M14.5 12.5L10 7L5.5 12.5H14.5Z"
        stroke={color || "#464C52"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronDownBlack = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path d="M5.5 7.5L10 13L14.5 7.5" fill="#464C52" />
      <path
        d="M5.5 7.5L10 13L14.5 7.5H5.5Z"
        stroke={color || "#464C52"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronRightBlack = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "9"}
      height={height || "11"}
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M7.11797 5.78237C7.23239 5.70617 7.32736 5.5968 7.39337 5.46521C7.45939 5.33361 7.49414 5.18441 7.49414 5.03255C7.49414 4.88069 7.45939 4.73149 7.39337 4.5999C7.32736 4.4683 7.23239 4.35893 7.11797 4.28273L1.83288 0.815354C1.71816 0.73931 1.58803 0.699258 1.45556 0.699219C1.3231 0.69918 1.19295 0.739155 1.0782 0.815132C0.963445 0.891108 0.868122 1.00041 0.8018 1.13206C0.735479 1.26372 0.700494 1.41309 0.700358 1.56517V8.49993C0.700494 8.65202 0.735479 8.80139 0.8018 8.93304C0.868122 9.06469 0.963445 9.174 1.0782 9.24997C1.19295 9.32595 1.3231 9.36592 1.45556 9.36589C1.58803 9.36585 1.71816 9.32579 1.83288 9.24975L7.11797 5.78237Z"
        fill={color || "#26282B"}
        stroke={color || "#26282B"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export {
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  ChevronUpBlack,
  ChevronDownBlack,
  ChevronRightBlack,
};
